import React, { useEffect, useState, useMemo } from 'react'
import { Spin } from 'antd'
import qs from 'qs'
import { useRequest } from 'ahooks'
import { useNavigate } from 'react-router-dom'
import Modal from 'meinian-package/src/baseComponent/modal'
import request from 'meinian-package/src/utils/request'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { getIpadVh } from 'common/ipad'
import OperationView from './operationView'
import InfoView, { IMAGE_DETAIL_TAB } from './infoView'
import Recommend from '../imageDetail/infoView/recommend'
import { ImageDetailContext } from './content'
import type { SampleDetailContext } from './content'
import styles from './index.module.less'

export default ({
  visible,
  list,
  maxListLength,
  onChangeIndex,
  onChange,
  initWaterfall,
  initSubColls,
  onVisibleChange,
  onDeleteItem,
}) => {
  return <Modal
    visible={visible}
    style={{ width: '100vw', height: '100vh', borderRadius: 0, overflow: 'hidden' }}
    hiddenCloseIcon
    className={styles.mnImageDetail}
    hiddenFooter
  >
    <DetailContent
      list={list}
      maxListLength={maxListLength}
      onChangeIndex={onChangeIndex}
      onChange={onChange}
      initWaterfall={initWaterfall}
      initSubColls={initSubColls}
      onVisibleChange={onVisibleChange}
      onDeleteItem={onDeleteItem}
      type="modal"
    />
  </Modal>
}

export type TDetailContentProps = {
  list?: Array<any>,
  onChangeIndex?: (arg:number)=>void,
  maxListLength?:number,
  onChange?:any,
  initWaterfall?:any,
  initSubColls?:any,
  onVisibleChange?:any,
  onDeleteItem?:(id: number)=>void,
  type?:string,
}

export const DetailContent = ({
  list = [],
  onChangeIndex,
  maxListLength = 0,
  onChange,
  initWaterfall,
  initSubColls,
  onVisibleChange,
  onDeleteItem,
  type,
}:TDetailContentProps) => {
  const naviage = useNavigate()
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [currentIndexInList, setCurrentIndexInList] = useState(list.findIndex(item => item.sampleCode === query.sampleCode))

  const [imgInfoList, setImgInfoList] = useState<Array<any>>([])
  const [innerIndex, setInnerIndex] = useState<number>(0)
  const [banOperation, setBanOperation] = useState<boolean>(false) // 禁止操作
  const [tabValue, setTabValue] = useState<IMAGE_DETAIL_TAB>(IMAGE_DETAIL_TAB.INFO)
  const [boxIndex, setBoxIndex] = useState(0)
  const [isMove, setIsMove] = useState(false)
  const [isAnnotate, setIsAnnotate] = useState(false)
  const [activeNoteIndex, setActiveNoteIndex] = useState(0)
  const [notes, setNotes] = useState([])
  const [showRight, setShowRight] = useState(false)
  const isPage = type !== 'modal'

  const currentImage: any = useMemo(() => {
    return imgInfoList[innerIndex] || {}
  }, [innerIndex, imgInfoList])

  const { loading, run: runImgsData } = useRequest(async () => {
    const result:any = await request.get('/zhikuan/mn/sample/query-sample-detail', { params: { sampleCode: query.sampleCode } })
    if (result.imgUrlList.length > 0) {
      const convertList = result.imgUrlList.map(item => {
        return {
          ...result,
          imageId: item.id,
          width: item.width,
          height: item.height,
          mainUrl: item.mainUrl,
          annotationNum: item.annotationNum
        }
      })
      setImgInfoList(convertList)
      setInnerIndex(0)
    }
  }, {
    refreshDeps: [query.sampleCode]
  })

  const { data: commentTotal = 0, run: runCommentTotal } = useRequest(async () => {
    if (currentImage.id) {
      const res:any = await request.get('/zhikuan/ins/inspiration/exclude/count-user-comment', {
        params: {
          userId: currentImage?.createUserId,
          collectOrSampleId: currentImage?.id,
          type: 1,
        }
      })
      return res
    }
  }, {
    ready: currentImage.id,
    refreshDeps: [currentImage]
  })

  const onInit = () => {
    setInnerIndex(0)
    runCommentTotal()
    runImgsData()
  }

  useEffect(() => {
    const onKeyDown = (e) => {
      if (banOperation) {
        return
      }
      if (e.keyCode === 38 && imgInfoList[innerIndex - 1]) {
        setInnerIndex(innerIndex - 1)
      }
      if (e.keyCode === 40 && imgInfoList[innerIndex + 1]) {
        setInnerIndex(innerIndex + 1)
      }
      if (e.keyCode === 37 && currentIndexInList - 1 >= 0 && tabValue !== IMAGE_DETAIL_TAB.RECOMMEND) {
        setInnerIndex(0)
        onOuterChange(currentIndexInList - 1)
      }
      if (e.keyCode === 39 && currentIndexInList + 1 < maxListLength && tabValue !== IMAGE_DETAIL_TAB.RECOMMEND) {
        setInnerIndex(0)
        onOuterChange(currentIndexInList + 1)
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [imgInfoList, innerIndex, banOperation, tabValue])

  const onOuterChange = (val: number) => {
    const cur = list[val]
    history.replaceState({}, '', `/meinian/detail/sample/image?sampleCode=${cur.sampleCode}`)
    setCurrentIndexInList(val)
    onChangeIndex?.(val)
  }

  const { run: fetchNotes } = useRequest(async () => {
    const res:any = await request.post('/zhikuan/annotation/get-inspiration-blog-annotation', {
      mainUrl: currentImage?.mainUrl,
      targetId: query.sampleCode,
      type: 1,
    })
    if (res.baseBlogAnnotationDTOList) {
      setNotes(res.baseBlogAnnotationDTOList
        .map(m => ({ ...m, confirm: true, width: currentImage.width, height: currentImage.height })))
    }
  }, {
    ready: !!currentImage?.mainUrl,
    refreshDeps: [currentImage?.mainUrl]
  })

  useEffect(() => {
    if (query.commentId) {
      setTabValue(IMAGE_DETAIL_TAB.COMMENT)
    }
    if (query.postilId && currentImage?.mainUrl) {
      const _index = imgInfoList.findIndex((item) => item.id === query.postilId)
      if (_index !== -1) {
        setInnerIndex(_index)
      }
      setTabValue(IMAGE_DETAIL_TAB.ANNOTATION)
    }
  }, [currentImage?.mainUrl])

  const them: SampleDetailContext = useMemo(() => ({
    tabValue,
    onTabChange: (val) => setTabValue(val),
    currentImage,
    onInit,
    initWaterfall: () => {
      initWaterfall?.()
      initSubColls?.()
    },
    onChange,
    setBanOperation,
    onVisibleChange,
    boxIndex,
    setBoxIndex,
    onDeleteItem: () => {
      onDeleteItem(currentImage.id)
    },
    //
    commentTotal,
    onInitCommentTotal: runCommentTotal,
    // 批注
    notes,
    setNotes,
    onInitNotes: fetchNotes,
    isMove,
    setIsMove,
    activeNoteIndex,
    setActiveNoteIndex,
    isAnnotate,
    setIsAnnotate,
    showRight,
    setShowRight,
    isPage,
  }), [tabValue, currentImage, boxIndex, notes, isMove, activeNoteIndex, isAnnotate, isPage, commentTotal, showRight])

  return <ImageDetailContext.Provider value={them}>
    <div
      className={classNames(styles.close, 'fill-grey-bg')}
      onClick={() => {
        if (!isPage) {
          onVisibleChange?.(false)
        } else {
          naviage('/home')
        }
      }}
    ><Icon type="m-guanbi" /></div>
    <div className={styles.mnImageDetailContent} style={{ height: getIpadVh() }}>
      <Spin spinning={loading}>
        <div className={styles.mnImageDetailContentWrap}>
          <OperationView
            imgInfoList={imgInfoList}
            currentImage={currentImage}
            setImgInfoList={setImgInfoList}
            innerIndex={innerIndex}
            setInnerIndex={setInnerIndex}
            setBanOperation={(val) => setBanOperation(val)}
            onInit={onInit}
            maxListLength={maxListLength}
            currentIndexInList={currentIndexInList}
            onOuterChange={onOuterChange}
            tabValue={tabValue}
            isAnnotate={isAnnotate}
            setIsAnnotate={setIsAnnotate}
          />
          <InfoView />
        </div>
      </Spin>
      {tabValue === IMAGE_DETAIL_TAB.RECOMMEND && <Recommend tabValue={tabValue} imgInfoList={imgInfoList} />}
    </div>
  </ImageDetailContext.Provider>
}
